module.exports = __webpack_public_path__ + "img/prod-6.c536eb10.png";